let errorsObj = {
  cnd_work_job_title: "",
  cnd_work_qualification: "",
  cnd_work_mode_of_travel: "",
  cnd_work_travel_range: "",
  // cnd_work_minpay:''
};

export const WorkPrefrenceValidations = (data) => {
  let error = false;
  const errorObj = { ...errorsObj };
  if (data.cnd_work_job_title === "") {
    errorObj.cnd_work_job_title = "Job Title Field Required";
    error = true;
  }
  if (data.cnd_work_qualification === "") {
    errorObj.cnd_work_qualification = "Work Qualification Field is Required";
    error = true;
  } else {
    let uploadEl = document.getElementById(
      "cnd_qualification_documents_uploaded_file"
    );
    if (
      uploadEl &&
      uploadEl.value == ""
    ) {
      errorObj.cnd_qualification_documents_uploaded_file =
        "Please upload the qualification document!";
      error = true;
      let msgEl = document.getElementById("cnd_qualification_documents_uploaded_file_msg");
      if (msgEl) msgEl.innerText = "Please upload the qualification document!";
    } else {
      let msgEl = document.getElementById("cnd_qualification_documents_uploaded_file_msg");
      if (msgEl) msgEl.innerText = "";
    }
  }

  if (data.cnd_work_mode_of_travel === "") {
    errorObj.cnd_work_mode_of_travel = "Work Mode of Travel Field is Required";
    error = true;
  }
  if (data.cnd_work_travel_range === "") {
    errorObj.cnd_work_travel_range = "Work Travel Range Field is Required";
    error = true;
  } else if (
    data.cnd_work_travel_range &&
    data.cnd_work_travel_range.trim() == ""
  ) {
    errorObj.cnd_work_travel_range = "Enter the valid Work Travel Range";
    error = true;
  }
  // if (data.cnd_work_minpay === "") {
  //   errorObj.cnd_work_minpay = "Work Min Pay Field is Required";
  //   error = true;
  // }

  return { stateData: errorObj, error: error };
};
